import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PinPage from './pages/PinPage';
import UnsubPage from './pages/UnsubPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import SuccessPage from './pages/SuccessPage';

function App()
{
  return (
    <Router>
      <Routes>
        <Route path="/" element={<PinPage />} />
        <Route path="/unsub" element={<UnsubPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/success" element={<SuccessPage />} />
      </Routes>
    </Router>
  );
}

export default App;
